<template>
    <div>
        <div>
            <!-- SELECT LABEL -->
            <el-form-item
                :label="$t.__('dashboard.forms.TaskSettingForm.label_to_display')"
                prop="labels"
            >
                <el-select v-model="form.labels" multiple class="wp-4">
                    <el-option
                        v-for="label in labels"
                        :key="label.id"
                        :label="label.value"
                        :value="label.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <!-- SUBMIT -->
            <div class="aright mt-5">
                <CompassButton
                    :label="$t.__('common.actions.cancel')"
                    type="secondary"
                    @click="close"
                />
                <CompassButton
                    :label="$t.__('common.actions.save')"
                    type="primary"
                    class="ml-3"
                    @click="submitForm"
                />
            </div>
        </div>
    </div>
</template>

<script>
import SettingsFormMixin from './SettingsFormMixin.js';

export default {
    mixins: [SettingsFormMixin],
    created() {
        this.$emit('updateLoading', { loading: true });
        this.$ajax.get('/rest/task/label', {}, (data) => {
            this.labels = data;
            this.$emit('updateLoading', { loading: false });
        });
    },
    data() {
        return {
            labels: [],
        };
    },
    methods: {
        close() {
            this.$emit('close-form');
        },
    },
};
</script>
